<template>
    <div class="status-selector-wrapper">
        <al-switch
            ontext="Enabled"
            offtext="Disabled"
            class="status-selector"
            :checked="value"
            @change="updateValue"
            style="
                --switch-width: 100px;
                /*--switch-height: 28px;*/
                /*--switch-gap: 2px;*/
                /*--switch-border-size: 1px;*/
            "
        />
    </div>
</template>

<script setup lang="ts">
import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';
import { WorkstreamState } from '@/pages/OperationsAdministration/types/WorkstreamState';
import { updateGridData } from '@/pages/OperationsAdministration/utils/updateGridData';
import {
    updateState,
    WorkstreamDefinitionOperationConfigGridRow
} from '@/pages/OperationsAdministration/types/WorkstreamDefinitionOperationConfigGridRow';

type Props = { params: ICellRendererParams<WorkstreamDefinitionOperationConfigGridRow, WorkstreamState> };
const props = defineProps<Props>();

const value = computed(() => {
    return (props.params.valueFormatted || props.params.value) === WorkstreamState.enabled;
});

function updateValue(event: Event) {
    const target = <HTMLInputElement>event.target;

    const newState = target.checked ? WorkstreamState.enabled : WorkstreamState.disabled;
    const updated = updateState(props.params.node.data, newState);

    if (updated) {
        updateGridData(props.params.api, [updated]);
    }
}
</script>

<style lang="scss">
div.status-selector-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: min-content;
}

.status-cell > .ag-cell-wrapper,
.status-cell > .ag-cell-wrapper > .ag-cell-value {
    display: contents;
}
</style>
